// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__wbH7S","selects":"Documents_selects__13qbj"};